// mds-dojo — dojo/errors/create — FAITHFUL port of references/dojo/errors/create.js.
// Factory for Error subclasses (used by CancelError, RequestError, etc.).
import lang from '../_base/lang';

export default function create(name: string, ctor?: any, base?: any, props?: any): any {
  base = base || Error;

  const ErrorCtor: any = function (this: any, message?: any) {
    if (base === Error) {
      if ((Error as any).captureStackTrace) {
        (Error as any).captureStackTrace(this, ErrorCtor);
      }
      // Error.call() operates on the returned error object, not |this|.
      const err: any = Error.call(this, message);
      for (const prop in err) {
        if (err.hasOwnProperty(prop)) { this[prop] = err[prop]; }
      }
      this.message = message;
      this.stack = err.stack;
    } else {
      base.apply(this, arguments as any);
    }
    if (ctor) {
      ctor.apply(this, arguments as any);
    }
  };

  ErrorCtor.prototype = lang.delegate(base.prototype, props);
  ErrorCtor.prototype.name = name;
  ErrorCtor.prototype.constructor = ErrorCtor;

  return ErrorCtor;
}
